(ns frontend.test.select.model)

(def sample-options
  (->> (range 0 100000)
       (map (fn [i]
              {:value i
               :label (str "option " i)}))))

(def sample-memory-options
  (->> sample-options
       (map-indexed (fn [i opt]
                      (when (= 0 (mod i 10))
                        opt)))
       (remove nil?)
       (take 200)))

(def StateSchema
  [:map
   [:async-select-value [:vector [:map [:value :label]]]]
   ])


(def root-path [::state])

(def single-select-value-path [:single-select-value])
(def single-select-value-full-path (vec (concat root-path single-select-value-path)))

(def multi-select-value-path [:multi-select-value])
(def multi-select-value-full-path (vec (concat root-path multi-select-value-path)))

(def async-select-value-path [:async-select-value])
(def async-select-value-full-path (vec (concat root-path async-select-value-path)))

(def async-select-multi-value-path [:async-select-multi-value])
(def async-select-multi-value-full-path (vec (concat root-path async-select-multi-value-path)))

(defn set-single-value
  [db value]
  {:db (assoc-in db single-select-value-full-path value)})

(defn set-multi-value
  [db value]
  {:db (assoc-in db multi-select-value-full-path value)})


(defn set-async-value
  [db value]
  {:db (assoc-in db async-select-value-full-path value)})

(defn set-async-multi-value
  [db value]
  {:db (assoc-in db async-select-multi-value-full-path value)})
